import PropTypes from 'prop-types';
import { Button } from 'ypf-pas-general-ui-components';

const ButtonsView = ({ viewOptions, setViewOptions }) => (
  <div className="d-flex w-25">
    <div>
      <Button
        label="Día"
        onClick={() => {
          setViewOptions('daily');
        }}
        type="button"
        variant={viewOptions.includes('daily') ? 'primary' : 'outline-primary'}
        widthButton="100px"
      />
    </div>
    <div className="mx-2">
      <Button
        label="Semana"
        onClick={() => {
          setViewOptions('weekly');
        }}
        type="button"
        variant={viewOptions.includes('weekly') ? 'primary' : 'outline-primary'}
        widthButton="100px"
      />
    </div>
    <div>
      <Button
        label="Mes"
        onClick={() => {
          setViewOptions('monthly');
        }}
        type="button"
        variant={viewOptions.includes('monthly') ? 'primary' : 'outline-primary'}
        widthButton="100px"
      />
    </div>
  </div>
);

ButtonsView.propTypes = {
  viewOptions: PropTypes.string.isRequired,
  setViewOptions: PropTypes.func.isRequired
};

export default ButtonsView;
